import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import toast from 'react-hot-toast';
import { useGetUserCampaignInvitations, useInviteGuest, useReserveMask } from 'api/invite/hooks';
import { MaskSelection } from '../maskSelection';
import Styles from './guestInviteStep.module.scss';

export const GuestInviteStep = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const [newCampaignInviteID, setNewCampaignInviteID] = useState('');
	const [step, setStep] = useState(0);
	const [guestInfo, setGuestInfo] = useState({
		firstName: '',
		lastName: '',
		maskID: ''
	});

	const restaurantID = searchParams.get('restaurantID');
	const campaignID = searchParams.get('campaignID');
	const userID = localStorage.getItem('invitee_user_id');

	const inviterName = `${searchParams.get('firstName')} ${searchParams.get('lastName')}`;

	const {
		data: userCampaignInvitations,
		isFetching: isFetchingInvites
	} = useGetUserCampaignInvitations({
		restaurantID,
		campaignID,
		userID
	});

	const { mutate: reserveMask } = useReserveMask({
		onSuccess: () => {
			toast.success(`Congratulations! ${guestInfo.firstName}'s mask has been reserved`);

			navigate({
				pathname: '/invitation/account',
				search: `?${searchParams.toString()}`
			});
		},
		onError: (error) => {
			const defaultMessage = 'Something went wrong while reserving mask';
			const responseMessage = error?.response?.data?.message;

			const errorMessage = responseMessage && responseMessage.length <= 100
				? responseMessage
				: defaultMessage;

			toast.error(errorMessage);
		},
	});

	const { mutate: inviteGuest } = useInviteGuest({
		onSuccess: (data) => {
			if (data.campaign_invite) {
				setNewCampaignInviteID(data.campaign_invite.id);
			}

			setStep(2);
		},
		onError: (error) => {
			const defaultMessage = 'Something went wrong while inviting guest';
			const responseMessage = error?.response?.data?.message;

			const errorMessage = responseMessage && responseMessage.length <= 100
				? responseMessage
				: defaultMessage;

			toast.error(errorMessage);
		},
	});

	useEffect(() => {
		if (
			userCampaignInvitations
			&& userCampaignInvitations.campaign_invites
			&& userCampaignInvitations.campaign_invites.length > 0
		) {
			const existingCampaignInvite = userCampaignInvitations.campaign_invites[0];

			if (existingCampaignInvite.user_campaign_rewards.length > 0) {
				navigate({
					pathname: '/invitation/account',
					search: `?${searchParams.toString()}`
				});
			} else {
				setNewCampaignInviteID(existingCampaignInvite.campaign_invites[0].id);
				setGuestInfo({
					firstName: existingCampaignInvite.invitee.first_name,
					lastName: existingCampaignInvite.invitee.last_name
				});
				setStep(2);
			}
		}
	}, [userCampaignInvitations, navigate, searchParams]);

	return (
		<>
			{!isFetchingInvites && step === 0 && (
				<div>
					<h3>Will our esteemed guest, {inviterName}, be bringing a guest with them?</h3>
					<div className='d-flex gap-4 mt-5'>
						<button onClick={() => setStep(1)} className={Styles.continue}>Yes</button>
						<button
							onClick={() => {
								navigate({
									pathname: '/invitation/account',
									search: `?${searchParams.toString()}`
								});
							}}
							className={Styles.cancel}>
							No
						</button>
					</div>
				</div >
			)}
			{
				step === 1 && (
					<div className='d-flex flex-column gap-4'>
						<h3>What is the name of the guest you'll be bringing?</h3>
						<div className='d-flex flex-column flex-md-row gap-3'>
							<input
								value={guestInfo?.firstName}
								onChange={(e) => {
									setGuestInfo((prev) => ({ ...prev, firstName: e.target.value }));
								}}
								className={`${Styles.input} ${Styles.small}`}
								placeholder='First Name'
							/>
							<input
								value={guestInfo?.lastName}
								onChange={(e) => {
									setGuestInfo((prev) => ({ ...prev, lastName: e.target.value }));
								}}
								className={`${Styles.input} ${Styles.small}`}
								placeholder='Last Name'
							/>
						</div>
						<button
							disabled={
								!guestInfo.firstName
								|| !guestInfo.lastName
								|| !userID
								|| !restaurantID
								|| !campaignID
							}
							onClick={() => inviteGuest({
								restaurantID,
								campaignID,
								firstName: guestInfo.firstName,
								lastName: guestInfo.lastName,
								inviterUserID: userID,
								isGuest: true
							})}
							className={Styles.continue}>
							Continue
						</button>
					</div>
				)
			}
			{
				step === 2 && (
					<div className='d-flex flex-column gap-4'>
						<MaskSelection
							reserveMask={reserveMask}
							heading={`Let's make sure that ${guestInfo.firstName} have an amazing mask as well`}
							guestCampaignInviteID={newCampaignInviteID}
							guestInvite
						/>
					</div>
				)
			}
		</>
	);
};
